import { useEffect, useState } from "react";
import dayjs from "dayjs";

export const clearCacheData = async () => {
	if ("caches" in window) {
		const cacheNames = await caches.keys();
		await Promise.all(
			cacheNames.map(async (name) => {
				try {
					await caches.delete(name);
				} catch (e) {
					console.warn("Failed to delete cache:", name, e);
				}
			}),
		);
	}

	try {
		const fetchVersion = await fetch("/meta.json?cache=" + Date.now()); // bust cache
		const { version } = await fetchVersion.json();
		localStorage.setItem("appVersion", version);
		localStorage.setItem("appVersionUpdated", dayjs().format("MM/DD/YY"));
	} catch (error) {
		console.error("Error fetching version:", error);
		const fetchVersion = await fetch("/meta.json?cache=" + Date.now()); // bust cache
		const { version } = await fetchVersion.json();
		localStorage.setItem("appVersion", version);
		localStorage.setItem("appVersionUpdated", dayjs().format("MM/DD/YY"));
	}

	window.location.reload();
};

export default function ClearCache(props) {
	const { children } = props;
	const [isLatestVersion, setIsLatestVersion] = useState(true);

	useEffect(() => {
		const checkForUpdates = async () => {
			try {
				const fetchVersion = await fetch("/meta.json?cache=" + Date.now()); // bust cache
				const { version } = await fetchVersion.json();

				const storedVersion = localStorage.getItem("appVersion");
				const storedDate = localStorage.getItem("appVersionUpdated");

				if (!storedVersion) {
					localStorage.setItem("appVersion", version);
					localStorage.setItem("appVersionUpdated", dayjs().format("MM/DD/YY"));
				} else {
					if (storedVersion !== version) {
						localStorage.setItem("appVersion", storedVersion);
						localStorage.setItem(
							"appVersionUpdated",
							storedDate ? storedDate : dayjs().format("MM/DD/YY"),
						);
						setIsLatestVersion(false);
					}
				}
			} catch (error) {
				const storedVersion = localStorage.getItem("appVersion");
				const storedDate = localStorage.getItem("appVersionUpdated");
				console.error("Error checking for updates:", error);
				localStorage.setItem("appVersion", storedVersion);
				localStorage.setItem("appVersionUpdated", storedDate);
			}
		};

		checkForUpdates();

		const interval = setInterval(
			() => {
				checkForUpdates();
			},
			5 * 60 * 1000,
		); // Check every 5 minutes

		return () => clearInterval(interval);
	}, []);

	return children({ isLatestVersion, emptyCacheStorage: clearCacheData });
}
